export default __webpack_public_path__ + "static/media/roman_2.56dc8ea4.svg";